import ClassifierConfigTable from '../ClassifierConfigTable'
import { ClassifierCoverageRow } from '../../types'

// Classifiers applied to the @AcmeUK · YouTube profile. Applications are flat
// (classifier, profile) pairs — how they got here (direct add, or a bulk-add via
// the team or organisation) doesn't matter and isn't tracked.
const rows: ClassifierCoverageRow[] = [
    { classifierId: 'hate-harassment', liveVersion: 3, appliedProfiles: 1, totalProfiles: 1 },
    { classifierId: 'spam-scams', liveVersion: 6, appliedProfiles: 1, totalProfiles: 1 },
    { classifierId: 'self-harm', liveVersion: 2, appliedProfiles: 1, totalProfiles: 1 },
    { classifierId: 'competitor-mentions', liveVersion: 1, appliedProfiles: 1, totalProfiles: 1 },
    { classifierId: 'brand-risk-imagery', liveVersion: 1, appliedProfiles: 1, totalProfiles: 1 }
]

export default function ClassifiersTab() {
    return (
        <div className="rounded-lg border border-gray-200 bg-white">
            <div className="flex items-center justify-between border-b border-gray-100 px-4 py-2.5">
                <span className="text-[13px] font-semibold text-gray-900">
                    Classifiers applied to this profile
                </span>
                <div className="flex items-center gap-3">
                    <span className="text-xs font-normal text-gray-800">{rows.length} applied</span>
                    <button
                        type="button"
                        className="rounded border border-arwen-200 bg-arwen-50 hover:bg-arwen-100 px-2.5 py-1 text-xs font-semibold text-arwen-700"
                    >
                        + Add classifier
                    </button>
                </div>
            </div>
            <ClassifierConfigTable level="profile" rows={rows} />
        </div>
    )
}
